/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedClaimClaimIdClaimRouteImport } from './routes/_authenticated/claim.$claimId/_claim'
import { Route as AuthenticatedClaimClaimIdClaimIndexRouteImport } from './routes/_authenticated/claim.$claimId/_claim/index'
import { Route as AuthenticatedClaimClaimIdClaimDocumentsRouteImport } from './routes/_authenticated/claim.$claimId/_claim/documents'
import { Route as AuthenticatedClaimClaimIdClaimDataIndexRouteImport } from './routes/_authenticated/claim.$claimId/_claim/data/index'
import { Route as AuthenticatedClaimClaimIdClaimBusinessIndexRouteImport } from './routes/_authenticated/claim.$claimId/_claim/business/index'
import { Route as AuthenticatedClaimClaimIdquestionnaireBusinessPageRouteImport } from './routes/_authenticated/claim.$claimId/(questionnaire)/business.$page'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClaimClaimIdClaimRoute =
  AuthenticatedClaimClaimIdClaimRouteImport.update({
    id: '/claim/$claimId/_claim',
    path: '/claim/$claimId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClaimClaimIdClaimIndexRoute =
  AuthenticatedClaimClaimIdClaimIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClaimClaimIdClaimRoute,
  } as any)
const AuthenticatedClaimClaimIdClaimDocumentsRoute =
  AuthenticatedClaimClaimIdClaimDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedClaimClaimIdClaimRoute,
  } as any)
const AuthenticatedClaimClaimIdClaimDataIndexRoute =
  AuthenticatedClaimClaimIdClaimDataIndexRouteImport.update({
    id: '/data/',
    path: '/data/',
    getParentRoute: () => AuthenticatedClaimClaimIdClaimRoute,
  } as any)
const AuthenticatedClaimClaimIdClaimBusinessIndexRoute =
  AuthenticatedClaimClaimIdClaimBusinessIndexRouteImport.update({
    id: '/business/',
    path: '/business/',
    getParentRoute: () => AuthenticatedClaimClaimIdClaimRoute,
  } as any)
const AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute =
  AuthenticatedClaimClaimIdquestionnaireBusinessPageRouteImport.update({
    id: '/claim/$claimId/(questionnaire)/business/$page',
    path: '/claim/$claimId/business/$page',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/claim/$claimId': typeof AuthenticatedClaimClaimIdClaimRouteWithChildren
  '/claim/$claimId/documents': typeof AuthenticatedClaimClaimIdClaimDocumentsRoute
  '/claim/$claimId/': typeof AuthenticatedClaimClaimIdClaimIndexRoute
  '/claim/$claimId/business/$page': typeof AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute
  '/claim/$claimId/business/': typeof AuthenticatedClaimClaimIdClaimBusinessIndexRoute
  '/claim/$claimId/data/': typeof AuthenticatedClaimClaimIdClaimDataIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/claim/$claimId/documents': typeof AuthenticatedClaimClaimIdClaimDocumentsRoute
  '/claim/$claimId': typeof AuthenticatedClaimClaimIdClaimIndexRoute
  '/claim/$claimId/business/$page': typeof AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute
  '/claim/$claimId/business': typeof AuthenticatedClaimClaimIdClaimBusinessIndexRoute
  '/claim/$claimId/data': typeof AuthenticatedClaimClaimIdClaimDataIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/claim/$claimId/_claim': typeof AuthenticatedClaimClaimIdClaimRouteWithChildren
  '/_authenticated/claim/$claimId/_claim/documents': typeof AuthenticatedClaimClaimIdClaimDocumentsRoute
  '/_authenticated/claim/$claimId/_claim/': typeof AuthenticatedClaimClaimIdClaimIndexRoute
  '/_authenticated/claim/$claimId/(questionnaire)/business/$page': typeof AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute
  '/_authenticated/claim/$claimId/_claim/business/': typeof AuthenticatedClaimClaimIdClaimBusinessIndexRoute
  '/_authenticated/claim/$claimId/_claim/data/': typeof AuthenticatedClaimClaimIdClaimDataIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/claim/$claimId'
    | '/claim/$claimId/documents'
    | '/claim/$claimId/'
    | '/claim/$claimId/business/$page'
    | '/claim/$claimId/business/'
    | '/claim/$claimId/data/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/claim/$claimId/documents'
    | '/claim/$claimId'
    | '/claim/$claimId/business/$page'
    | '/claim/$claimId/business'
    | '/claim/$claimId/data'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/'
    | '/_authenticated/claim/$claimId/_claim'
    | '/_authenticated/claim/$claimId/_claim/documents'
    | '/_authenticated/claim/$claimId/_claim/'
    | '/_authenticated/claim/$claimId/(questionnaire)/business/$page'
    | '/_authenticated/claim/$claimId/_claim/business/'
    | '/_authenticated/claim/$claimId/_claim/data/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claim/$claimId/_claim': {
      id: '/_authenticated/claim/$claimId/_claim'
      path: '/claim/$claimId'
      fullPath: '/claim/$claimId'
      preLoaderRoute: typeof AuthenticatedClaimClaimIdClaimRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claim/$claimId/_claim/': {
      id: '/_authenticated/claim/$claimId/_claim/'
      path: '/'
      fullPath: '/claim/$claimId/'
      preLoaderRoute: typeof AuthenticatedClaimClaimIdClaimIndexRouteImport
      parentRoute: typeof AuthenticatedClaimClaimIdClaimRoute
    }
    '/_authenticated/claim/$claimId/_claim/documents': {
      id: '/_authenticated/claim/$claimId/_claim/documents'
      path: '/documents'
      fullPath: '/claim/$claimId/documents'
      preLoaderRoute: typeof AuthenticatedClaimClaimIdClaimDocumentsRouteImport
      parentRoute: typeof AuthenticatedClaimClaimIdClaimRoute
    }
    '/_authenticated/claim/$claimId/_claim/data/': {
      id: '/_authenticated/claim/$claimId/_claim/data/'
      path: '/data'
      fullPath: '/claim/$claimId/data/'
      preLoaderRoute: typeof AuthenticatedClaimClaimIdClaimDataIndexRouteImport
      parentRoute: typeof AuthenticatedClaimClaimIdClaimRoute
    }
    '/_authenticated/claim/$claimId/_claim/business/': {
      id: '/_authenticated/claim/$claimId/_claim/business/'
      path: '/business'
      fullPath: '/claim/$claimId/business/'
      preLoaderRoute: typeof AuthenticatedClaimClaimIdClaimBusinessIndexRouteImport
      parentRoute: typeof AuthenticatedClaimClaimIdClaimRoute
    }
    '/_authenticated/claim/$claimId/(questionnaire)/business/$page': {
      id: '/_authenticated/claim/$claimId/(questionnaire)/business/$page'
      path: '/claim/$claimId/business/$page'
      fullPath: '/claim/$claimId/business/$page'
      preLoaderRoute: typeof AuthenticatedClaimClaimIdquestionnaireBusinessPageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedClaimClaimIdClaimRouteChildren {
  AuthenticatedClaimClaimIdClaimDocumentsRoute: typeof AuthenticatedClaimClaimIdClaimDocumentsRoute
  AuthenticatedClaimClaimIdClaimIndexRoute: typeof AuthenticatedClaimClaimIdClaimIndexRoute
  AuthenticatedClaimClaimIdClaimBusinessIndexRoute: typeof AuthenticatedClaimClaimIdClaimBusinessIndexRoute
  AuthenticatedClaimClaimIdClaimDataIndexRoute: typeof AuthenticatedClaimClaimIdClaimDataIndexRoute
}

const AuthenticatedClaimClaimIdClaimRouteChildren: AuthenticatedClaimClaimIdClaimRouteChildren =
  {
    AuthenticatedClaimClaimIdClaimDocumentsRoute:
      AuthenticatedClaimClaimIdClaimDocumentsRoute,
    AuthenticatedClaimClaimIdClaimIndexRoute:
      AuthenticatedClaimClaimIdClaimIndexRoute,
    AuthenticatedClaimClaimIdClaimBusinessIndexRoute:
      AuthenticatedClaimClaimIdClaimBusinessIndexRoute,
    AuthenticatedClaimClaimIdClaimDataIndexRoute:
      AuthenticatedClaimClaimIdClaimDataIndexRoute,
  }

const AuthenticatedClaimClaimIdClaimRouteWithChildren =
  AuthenticatedClaimClaimIdClaimRoute._addFileChildren(
    AuthenticatedClaimClaimIdClaimRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedClaimClaimIdClaimRoute: typeof AuthenticatedClaimClaimIdClaimRouteWithChildren
  AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute: typeof AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedClaimClaimIdClaimRoute:
    AuthenticatedClaimClaimIdClaimRouteWithChildren,
  AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute:
    AuthenticatedClaimClaimIdquestionnaireBusinessPageRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
